// extracted by mini-css-extract-plugin
export default {"rating":"HM-z","numberOfStars":"IM-z","count":"JM-z","barGraphSpacing":"KM-z","barGraph":"LM-z"};